export default __webpack_public_path__ + "static/media/card-badge.3e5d0dfd.svg";